//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ListHeader",
  components: {
    SimpleButton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    showBackButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    backLink() {
      return {
        name: "marketing-list"
      };
    }
  },
  methods: {
    toCreateList() {
      this.$router.push({
        path: `/marketing/lists/add`
      });
    }
  }
});